














import { Vue, Component, Prop } from "vue-property-decorator";

import { Tag } from '../../../api/models/Tag';

@Component
export default class TagList extends Vue {

    @Prop() tags: { tag: Readonly<Tag>; isSelected: boolean }[];
    @Prop({ default: false }) forceShowButton: boolean;
    @Prop({ default: 'small' }) modificationName: string;
    @Prop({ default: false }) isSelectable: boolean;
    @Prop({ default: false }) multiline: boolean;
    @Prop({ default: 9999 }) maxTagsToShow: number;
    @Prop({default: false}) dontHide: boolean;
    @Prop({ default: false }) isTransparent: boolean;
    @Prop({ default: false }) haveAnotherTags: boolean;

    mounted() {
        if (!this.multiline) {
            this.showFittedTags();
        }
        window.addEventListener('resize', this.resizeHandler);
    }

    updated() {
        if (!this.multiline) {
            this.showFittedTags();
        }
    }

    destroyed() {
        window.removeEventListener('resize', this.resizeHandler);
    }

    // определяем какие теги влезут в контейнер и их нужно показать
    showFittedTags() {
        if (this.dontHide) { return; }

        const container = (this.$refs['tags'] as HTMLElement),
            containerComputedStyles = window.getComputedStyle(container, null),
            tagElements: HTMLElement[] = Array.from(container.querySelectorAll('.tag-list__tag'));

        container.style.flex = '1';

        let commonWidth = 0,
            slotContent = this.$slots,
            moreButton = slotContent?.default?.[0].elm,
            moreButtonWidth = moreButton ? (moreButton as HTMLElement).clientWidth : 0,
            needMoreButton = false;
        const containerWith = container.clientWidth
            - parseInt(containerComputedStyles.getPropertyValue('padding-left') || "0")
            - parseInt(containerComputedStyles.getPropertyValue('padding-right') || "0");

        tagElements.forEach((tag, i) => {
            const padding = parseInt(window.getComputedStyle(tag, null).getPropertyValue('padding-right') || "0");
            if (tag.hidden) {
                tag.style.visibility = 'hidden';
                tag.hidden = false;
            }
            const potentialWidth = commonWidth + tag.clientWidth + padding +
                                   (i === tagElements.length - 1 && !this.forceShowButton ? 0 : moreButtonWidth);
            if (needMoreButton) {
                tag.hidden = true;
            } else if (potentialWidth > containerWith || i >= this.maxTagsToShow || containerWith === 0) {
                tag.hidden = true;
                needMoreButton = true;
            } else {
                tag.hidden = false;
                tag.style.visibility = 'visible';
            }
            commonWidth += tag.clientWidth + padding;
        });
        if ((needMoreButton || this.haveAnotherTags) && moreButton) {
            (moreButton as HTMLElement).style.visibility = 'visible';
        } else if(moreButton) {
            (moreButton as HTMLElement).style.visibility = 'hidden'
        }

        container.style.flex = 'unset';
    }

    onSelectTag(item: { tag: Readonly<Tag>; isSelected: boolean }) {
        if (this.isSelectable) {
            this.$emit('selectTag', item);
        }
    }

    resizeHandler() {
        if (!this.multiline) {
            this.showFittedTags();
        }
    }
}
